import { MultipartRedemptionBottomSheet as UIMultipartRedemptionBottomSheet, type MultipartRedemptionBottomSheetProps } from '@jagad/ui'
import { useTranslation } from 'react-i18next'
import { redirectToTelegramSupport } from '@lib/utils'

type Props = Omit<MultipartRedemptionBottomSheetProps, 'title' | 'requestedLabel' | 'disbursedLabel' | 'inProgressLabel' | 'returnedLabel' | 'alertText' | 'onContactSupport'>

const MultipartRedemptionBottomSheet = (props: Props) => {
    const { t } = useTranslation()
    return (
        <UIMultipartRedemptionBottomSheet
            {...props}
            title={t('components.multipartRedemptionBottomSheet.title')}
            requestedLabel={t('components.multipartRedemptionBottomSheet.requestedLabel')}
            disbursedLabel={t('components.multipartRedemptionBottomSheet.disbursedLabel')}
            inProgressLabel={t('components.multipartRedemptionBottomSheet.inProgressLabel')}
            returnedLabel={t('components.multipartRedemptionBottomSheet.returnedLabel')}
            alertText={t('components.multipartRedemptionBottomSheet.alertText')}
            onContactSupport={() => redirectToTelegramSupport('JagadCS_bot')}
        />
    )
}

export default MultipartRedemptionBottomSheet
